<script>
import Layout from '../../layouts/main';
import PageHeader from '@/components/page-header';
import axios from 'axios';
import { authFackMethods } from '@/state/helpers';

export default {
	page: {
		title: 'Actions',
		meta: [
			{
				name: 'Actions',
			},
		],
	},
	components: { Layout, PageHeader },
	data() {
		return {
			title: '',
			items: [
				{
					text: '',
					href: '/',
				},
			],
			assigned_tasks: {},
			preservePage: 1,
			pageLimit: 50,
			isLoading: false,
			aNoRecord: false,
			showAssignedTasks: false,
			currentUserData: JSON.parse(localStorage.getItem('user')),
		};
	},
	mounted() {
		this.showAssignedTasks = true;
		this.getAssignedTasks();
	},
	methods: {
		getAssignedTasks(page) {
			this.isLoading = true;
			this.aNoRecord = false;
			if (typeof page === 'undefined') {
				page = 1;
			}
			this.preservePage = page;
			let filter = '&per_page=' + this.pageLimit;
			filter += '&user_id=' + this.currentUserData.id;
			axios
				.get('admin/users/all/assigned_tasks?pagination=true&page=' + page + filter)
				.then((res) => {
					this.assigned_tasks = res.data.response;
					this.isLoading = false;
					if (!this.assigned_tasks.data.length) {
						this.aNoRecord = true;
						if (page > 1) {
							this.getAssignedTasks(page - 1);
						}
					}
				})
				.catch((err) => {
					this.aNoRecord = true;
					this.isLoading = false;
					if (err.response) {
						if (err.response.status == 401) {
							this.logout();
						}
					}
				});
		},
		...authFackMethods,

		getFullName(user) {
			let fullname = '';
			if (user.first_name && user.first_name.length) {
				fullname += user.first_name;
			}
			if (user.last_name && user.last_name.length) {
				fullname += ' ' + user.last_name;
			}
			return fullname;
		},
	},
};
</script>

<template>
	<Layout>
		<PageHeader :title="title" :items="items" />

		<div class="card" v-if="showAssignedTasks">
			<div class="card-body">
				<div class="d-flex">
					<div class="me-2">
						<h5 class="card-title mb-3">Assigned Tasks</h5>
					</div>
				</div>

				<div class="table-responsive">
					<table class="table table-bordered table-hover table-striped align-middle mb-0">
						<thead class="table-light">
							<tr>
								<th scope="col">Name</th>
								<th scope="col">Task</th>
								<th scope="col">Location</th>
								<th scope="col">Due Date</th>
								<th scope="col">Role</th>
							</tr>
						</thead>
						<tbody>
							<tr v-if="aNoRecord">
								<td colspan="5" class="p-0">
									<p class="font-size-16 text-center my-3">No tasks! All caught up!</p>
								</td>
							</tr>

							<tr v-if="isLoading">
								<td colspan="5" class="text-center p-0">
									<b-spinner class="m-2" variant="primary" role="status"></b-spinner>
								</td>
							</tr>

							<tr v-else v-for="(applicant, applicantIndex) in assigned_tasks.data" :key="applicantIndex">
								<td>
									<h5 class="font-size-13 text-truncate mb-1">
										<router-link tag="a" target="_blank" :to="`/approvals/user/${applicant?.approval_id}/${applicant?.id}`">
											{{ applicant && applicant.first_name ? getFullName(applicant) : applicant && applicant.username ? applicant.username : 'N/A' }}
										</router-link>
									</h5>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										<span v-if="applicant && applicant.psv_check == 'applicant'">Review Application</span>
										<span v-else>{{ applicant && applicant.user_current_status ? applicant.user_current_status : '' }}</span>
									</p>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										{{ applicant && applicant.location ? applicant.location : '' }}
									</p>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										{{ applicant && applicant.application_date ? applicant.application_date : '' }}
									</p>
								</td>

								<td>
									<p class="text-muted mb-0 text-wrap">
										{{ applicant && applicant.UserType ? applicant.UserType : '' }}
									</p>
								</td>
							</tr>
						</tbody>
					</table>
				</div>

				<pagination class="mt-4" :data="assigned_tasks" :limit="10" @pagination-change-page="getAssignedTasks"></pagination>
			</div>
		</div>
	</Layout>
</template>
